/* eslint-disable no-else-return */
import { BusinessLevels } from '../common/types';

interface MisSummaryData {
  level: BusinessLevels;
  panNumber: string;
  business: string;
  panOrgId: string;
  businessId: string;
}

export const getPanNumberAndBusiness = (
  businessHierarchy: any,
  orgId: string
) => {
  const currentBusiness = businessHierarchy.businessDataStore[orgId];
  if (currentBusiness.level === BusinessLevels.PAN) {
    const data: MisSummaryData = {
      level: BusinessLevels.PAN,
      panNumber: currentBusiness.pan,
      business: currentBusiness.pan,
      businessId: currentBusiness.id,
      panOrgId: orgId,
    };
    return data;
  } else if (currentBusiness.level === BusinessLevels.GSTIN) {
    const requiredPan =
      businessHierarchy.businessDataStore[currentBusiness.parentOrgUnitId];
    const data: MisSummaryData = {
      level: BusinessLevels.GSTIN,
      panNumber: requiredPan.pan,
      business: currentBusiness.gstin,
      businessId: currentBusiness.id,
      panOrgId: requiredPan.id,
    };
    return data;
  } else {
    const requiredGstin =
      businessHierarchy.businessDataStore[currentBusiness.parentOrgUnitId];
    const requiredPan =
      businessHierarchy.businessDataStore[requiredGstin.parentOrgUnitId];

    const data: MisSummaryData = {
      level: BusinessLevels.BRANCH,
      panNumber: requiredPan.pan,
      business: currentBusiness.name,
      businessId: currentBusiness.id,
      panOrgId: requiredPan.id,
    };
    return data;
  }
};

export const getSideDrawBizData = (businessHierarchy: any, orgId: string) => {
  const currentBusiness = businessHierarchy.businessDataStore[orgId];
  if (currentBusiness.level === BusinessLevels.PAN) {
    const details = `PAN: ${currentBusiness.pan}`;
    const data = {
      currentBizName: currentBusiness.name,
      currentBizDetails: details,
    };
    return data;
  } else if (currentBusiness.level === BusinessLevels.GSTIN) {
    const details = `GSTIN: ${currentBusiness.gstin}`;
    const data = {
      currentBizName: currentBusiness.name,
      currentBizDetails: details,
    };
    return data;
  } else {
    const requiredGstin =
      businessHierarchy.businessDataStore[currentBusiness.parentOrgUnitId];
    const details = `GSTIN: ${requiredGstin.gstin}`;
    const data = {
      currentBizName: currentBusiness.name,
      currentBizDetails: details,
    };
    return data;
  }
};
